import React from 'react';

const VendorItemsSkeleton = () => {
  return (
    <div className="min-h-screen bg-white animate-pulse">
      {/* Header Skeleton */}
      <div className='border-b border-gray-200 mb-4'>
        <div className="px-2 bg-white py-3 flex justify-between items-center sticky top-0 z-30">
          <div className="flex items-center">
            {/* Back arrow skeleton */}
            <div className="w-8 h-6 bg-gray-200 rounded mr-1"></div>
            <div className="flex items-center">
              {/* Vendor image skeleton */}
              <div className="w-6 h-6 bg-gray-200 rounded mr-2"></div>
              {/* Vendor name skeleton */}
              <div className="w-32 h-4 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Bar Skeleton (if needed) */}
      {/* <div className="px-4 pt-6 pb-2 bg-white sticky top-0 z-20">
        <div className="relative max-w-xl mx-auto">
          <div className="w-full h-10 bg-gray-200 rounded-md"></div>
        </div>
      </div> */}

      {/* Products Grid Skeleton */}
      <div className="px-4 py-4 pb-10 bg-white">
        <div className="bg-white">
          <div className="grid grid-cols-2 gap-4">
            {/* Generate 8 skeleton items */}
            {Array.from({ length: 8 }).map((_, index) => (
              <div key={index} className="flex flex-col">
                {/* Main Container for Image and Add Button with Gray Background */}
                <div className="rounded-xl bg-gray-100 overflow-hidden mb-3 relative pb-12 mx-1">
                  {/* Image Section Skeleton */}
                  <div className="h-24 flex items-center justify-center p-3">
                    <div className="h-16 w-16 bg-gray-200 rounded"></div>
                  </div>
                                                         
                  {/* Add Button Skeleton - Inside the same gray container */}
                  <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2">
                    <div className="w-16 h-6 bg-gray-200 rounded-md"></div>
                  </div>
                </div>

                {/* Product Info Skeleton - Outside the gray container */}
                <div className="flex flex-col items-start mx-1">
                  {/* Product name skeleton */}
                  <div className="w-full h-3 bg-gray-200 rounded mb-1"></div>
                  <div className="w-3/4 h-3 bg-gray-200 rounded mb-2"></div>
                  {/* Price skeleton */}
                  <div className="w-16 h-3 bg-gray-200 rounded"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* View Bucket Button Skeleton - Fixed at bottom */}
      <div className="fixed bottom-4 inset-x-0 z-50 flex justify-center px-4">
        <div className="w-48 h-12 bg-gray-200 rounded-full"></div>
      </div>
    </div>
  );
};

export default VendorItemsSkeleton;
